import { render } from "./AppCurrencyInput.vue?vue&type=template&id=aa189b24"
import script from "./AppCurrencyInput.vue?vue&type=script&lang=js"
export * from "./AppCurrencyInput.vue?vue&type=script&lang=js"
script.render = render

export default script